import React,{useState} from "react";
import Navbar from "../../navbar/navbar";
import { api } from "../../../services/api";
import { Link,Navigate, useParams } from 'react-router-dom'
import { useEffect } from "react";
import './banco.css'
import Banco from "./banco";
import { vhostV1 } from "../../funcoes";
import SweetAlert from "react-bootstrap-sweetalert";
import FooterBar from "../../footer/footerBar";





function NovoBanco(){
 

  const {tag} =useParams();
  const {id} =useParams();

  

   const [erroValidacao, setErrovalidacao] = useState(false); 
   const [msgErro,setmsgErro] = useState('');
   const [banco,setBanco] = useState(0);
   const [descricao,setDescricao] = useState('');
   const [cedente_caixaEcon,setcedente_caixaEcon] = useState('');
   const [conta_corrente,setConta_Corrente] = useState('0');
   const [cadastrado_por,setCadastrado_Por] = useState(99);
   const [alterado_por,setAlterado_Por] = useState(99)
   const [conc,setConc] = useState('S');
   const [num_carteira,setNum_carteira] = useState('0');
   const [desc_carteira,setDesc_Carteira] = useState('');
   const [num_conta,setNumConta] = useState('');
   const [digito_conta,setDigito_Conta] = useState(0);
   const [num_agencia,setNum_Agencia] = useState('');
   const [digito_agencia,setDigito_Agencia] = useState(0);
   const [tpJuros,setTpJuros] = useState('');
   const [tpMulta,setTpMulta] = useState('');
   const [inscob01,setINSCOB01] = useState('');
   const [insccob02,setINSCOB02] = useState('');
   const [multaCod,setMULTACOB] = useState(0);
   const [jurosCod,setJUROSCOB] = useState(0);
   const [localPagamento,setLOCALPAGAMENTO] = useState('');
   const [instrucao_cobranca,setINSTRUCAO_COBRANCA] = useState('');
   const [cedente_dv,setCEDENTE_DV] = useState(0);
   const [contaReduzida,setCONTAREDUZIDA] = useState('');
   const [usaBoleto,setUsaBoleto] = useState(false);

   const [sucesso,setSucesso] = useState('N')
   const [mensagem, setMensagem] = useState('');
   const [load, setLoad] = useState(false);
   const [sResult, setSresult] = useState(0);
   const [dataUltimoMov, setDataUltimoMov] = useState('');
   const [dataUltFormatada, setDataUltFormatada] = useState('');
   const [edicao, setEdicao] = useState(false);
 
   var data = new Date();

   const dataAtual = data.toSRIFormatString();
   console.log(dataUltimoMov);
   
   const formatDate = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };  

  const formatDateISOtoDMY = (isoDate) => {
    const date = new Date(isoDate); 
    
    if (isNaN(date)) return ''; 
    
    const day = date.getDate().toString().padStart(2, '0'); 
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear(); 
    
    return `${day}/${month}/${year}`; 
  };

  const formatDateEdition = (dateString) => {
    const [day, month, year] = dateString.split("/");
    return `${year}-${month}-${day}`;
  };
  
  

  

  useEffect(function(){
    if(dataUltimoMov !== null || ''){
        const dataFormatada = formatDateISOtoDMY(dataUltimoMov)
        console.log(dataFormatada);
        setDataUltFormatada(dataFormatada);
        
      }
  },[dataUltimoMov]);
  
 
  

   
   
  
   console.log('data formatada:', dataAtual); //2022

   let config = {
    headers: {
      'Authorization': localStorage.getItem("token")
    }
  }


  const handleJurosChange = (e) => {
    setTpJuros(e.target.value);
};

const handleMultaChange = (e) => {
    setTpMulta(e.target.value);
};

  console.log(id);
  

  useEffect(function(){   

    
      
    api.post(vhostV1('webcash/banco/'+id), {
        loja: localStorage.getItem('loja'),
        empresa: 0,
        seqBanco: Number(id)       
      },config)
      .then(function (response) {

        console.log(response);
        

       
    
         //buscaGrupos();
        if (response && response.data && response.data.dados){
            console.log(response.data.dados[0])
            console.log(formatDateISOtoDMY(response.data.dados[0].DATA_ULTIMO));
            
         setBanco(response.data.dados[0].BANCO); 
         setDescricao(response.data.dados[0].DESCRICAO);  
         setConta_Corrente(response.data.dados[0].CONTA_CORRENTE); 
         setcedente_caixaEcon(response.data.dados[0].CEDENTE_CAIXAECON); 
         setDataUltimoMov(formatDateISOtoDMY(response.data.dados[0].DATA_ULTIMO));
         setConc(response.data.dados[0].CONC);
         setNum_carteira(response.data.dados[0].NUM_CARTEIRA);
         setDesc_Carteira(response.data.dados[0].DESC_CARTEIRA);
         setNumConta(response.data.dados[0].NUM_CONTA);  
         setDigito_Conta(response.data.dados[0].DIGITO_CONTA); 
         setNum_Agencia(response.data.dados[0].NUM_AGENCIA);  
         setDigito_Agencia(response.data.dados[0].DIGITO_AGENCIA); 
         setTpJuros(response.data.dados[0].TPJUROS);
         setTpMulta(response.data.dados[0].TPMULTA);
         setINSCOB01(response.data.dados[0].INSCOB01);
         setINSCOB02(response.data.dados[0].INSCOB02);
         setMULTACOB(response.data.dados[0].MULTACOB);
         setLOCALPAGAMENTO(response.data.dados[0].LOCALPAGAMENTO);
         setINSTRUCAO_COBRANCA(response.data.dados[0].INSTRUCAO_COBRANCA);
         setCEDENTE_DV(response.data.dados[0].CEDENTE_DV);
         setCONTAREDUZIDA(response.data.dados[0].CONTAREDUZIDA);
         setJUROSCOB(response.data.dados[0].JUROSCOB);
         setEdicao(true);

        
          
    
   
        }           
        
                
      });

      
  },[])

  useEffect(() => {
    if (
      !cedente_caixaEcon &&
      !instrucao_cobranca &&
      !num_carteira &&
      !cedente_dv &&
      !localPagamento &&
      !tpJuros &&
      !tpMulta &&
      !inscob01 &&
      !insccob02
    ) {
      setUsaBoleto(false);  
    } else if (jurosCod && multaCod !== '0') {
      setUsaBoleto(true);  
    } else {
      setUsaBoleto(true);  
    }
  }, [edicao, cedente_caixaEcon, instrucao_cobranca, num_carteira, cedente_dv, localPagamento, tpJuros, tpMulta, inscob01, insccob02, jurosCod, multaCod]);
  console.log(usaBoleto);
  

  
   const json = {
    BANCO:Number(banco),
    SEQ_BANCO:Number(id),
    DESCRICAO:descricao.toUpperCase(),
    CEDENTE_CAIXAECON:cedente_caixaEcon,
    CONTA_CORRENTE:conta_corrente,
    DATA_ULTIMO:dataUltimoMov, 
    CADASTRADO_EM:dataAtual,
    CADASTRADO_POR:cadastrado_por,
    CONC:conc,
    NUM_CARTEIRA:num_carteira,
    DESC_CARTEIRA:desc_carteira,
    NUM_CONTA:num_conta,
    DIGITO_CONTA:Number(digito_conta),
    NUM_AGENCIA:num_agencia,
    DIGITO_AGENCIA:Number(digito_agencia),
    TPJUROS:tpJuros,
    TPMULTA:tpMulta,
    INSCOB01:inscob01,
    INSCOB02:insccob02,
    MULTACOB:Number(multaCod),
    JUROSCOB:(jurosCod),
    LOCALPAGAMENTO:localPagamento,
    INSTRUCAO_COBRANCA:instrucao_cobranca,
    CEDENTE_DV:Number(cedente_dv),
    CONTAREDUZIDA:contaReduzida
   }

   console.log(json);
   
   //buscar codigo banco

    function SalvaBanco(){

       // validar tamanhos 
      {if(descricao.length >30 )
        { setmsgErro("Descrição do banco maior que permitido");
         setErrovalidacao(true)}
       else if(cedente_caixaEcon.length >10)
       { setmsgErro("Cedente maior que permitido");
       setErrovalidacao(true)}
       else if (conta_corrente.length >10) 
       {setmsgErro("Conta corrente maior que permitido");
       setErrovalidacao(true)}
       else if (num_carteira.length >6)
       {setmsgErro("Numero da carteira maior que permitido");
       setErrovalidacao(true)}
       else if (num_agencia.length >4)
       {setmsgErro("Número da agência maior que permitido");
       setErrovalidacao(true)}
       else if(desc_carteira.length >28)
       {setmsgErro("Descrição da carteira maior que permitido");
       setErrovalidacao(true)}
       else if(num_conta.length >11)
       {setmsgErro("Numero da conta maior que permitido");
       setErrovalidacao(true) }
       else if(localPagamento.length >200)
       {setmsgErro("Local do Pagamento maior que permitido");
       setErrovalidacao(true)}
       else if(descricao.length === 0)
        { setmsgErro("Descrição não pode estar vazio");
        setErrovalidacao(true)}
       else if(dataUltimoMov.length === 0)
            { setmsgErro("Selecione uma data ultimo movimento");
            setErrovalidacao(true)}
       
        else {      
      
       // fim do valida tamanhos

           //   e.preventDefault(e);
        api.post(vhostV1('webcash/banco/incluir'),{
        
        BANCO:Number(banco),
        SEQ_BANCO:Number(id),
        DESCRICAO:descricao.toUpperCase(),
        CEDENTE_CAIXAECON:cedente_caixaEcon,
        CONTA_CORRENTE:conta_corrente,
        DATA_ULTIMO:dataUltimoMov, 
        CADASTRADO_EM:formatDateEdition(dataAtual),
        CADASTRADO_POR:cadastrado_por,
        CONC:conc,
        NUM_CARTEIRA:num_carteira,
        DESC_CARTEIRA:desc_carteira,
        NUM_CONTA:num_conta,
        DIGITO_CONTA:Number(digito_conta),
        NUM_AGENCIA:num_agencia,
        DIGITO_AGENCIA:Number(digito_agencia),
        TPJUROS:tpJuros,
        TPMULTA:tpMulta,
        INSCOB01:inscob01,
        INSCOB02:insccob02,
        MULTACOB:Number(multaCod),
        JUROSCOB:(jurosCod),
        LOCALPAGAMENTO:localPagamento,
        INSTRUCAO_COBRANCA:instrucao_cobranca,
        CEDENTE_DV:Number(cedente_dv),
        CONTAREDUZIDA:contaReduzida,
        USA_BOLETO:usaBoleto
        },config)
// >>>>>>> 30bf9c76b65afd409b3efacfda83d696d35387d5
        .then(function(response){
            console.log(response);
            
            if(response.data.result === 1 ){
                setMensagem('');
                setSucesso('S');
                }else{
                 setmsgErro(response)
                }
            }).catch((erro) =>{
                setMensagem(erro);
                setSucesso('N');
                console.log(erro);
            });
        }}
        };

    //busca

    console.log(dataUltimoMov);
    



     return <div className="conteiner-fluid titulo ">
        {/* {load ? <Loading />
         : <> */}
         <Navbar/>
         <div className="offset-lg-3 col-lg-6">
               <h2>Cadastro Banco</h2>      
                <hr />
                <div className="conteiner-fluid">
                    <form className="row tela">
                    
                    
                    
                    
                    <div className="col-md-6">
                        <label htmlFor="inputState" className="form-label">Banco</label>
                        <select id="inputState" value={banco} onChange={(e)=> setBanco(parseInt(e.target.value.substring(0,3)))} className="form-select">
                            <option value={0}>000 - Outros</option>
                            <option value={1}>001 - Banco Brasil</option>                                
                            <option value={4}>004 - BANCO NORDESTE DO BRASIL SA</option>        
                            <option value={8}>008 - BANCO SANTANDER BANESPA</option>            
                            <option value={29}>029 - BANCO BANERJ SA </option>   
                            <option value={33}>033 - BANCO ESTADO SAO PAULO BANESPA</option>    
                            <option value={38}>038 - BANCO BANESTADO </option>   
                            <option value={47}>047 - BANCO ESTADO SERGIPE SA</option>       
                            <option value={73}>073 - BANCO POPULAR DO BRASIL </option>           
                            <option value={104}>104 - CAIXA ECONOMICA FEDERAL </option>           
                            <option value={151}>151 - BANCO NOSSACAIXA </option>                  
                            <option value={175}>175 - BANCO FINASA </option>                      
                            <option value={215}>215 - BANCO COMERCIAL SUDAMERIS SA</option>       
                            <option value={237}>237 - BANCO BRADESCO SA</option>                  
                            <option value={252}>252 - BANCO FINIVEST </option>                    
                            <option value={263}>263 - BANCO CACIQUE </option>                     
                            <option value={265}>265 - BANCO FATOR </option>                       
                            <option value={318}>318 - BANCO BMG SA </option>                      
                            <option value={341}>341 - BANCO ITAU </option>                        
                            <option value={351}>351 - BANCO SANTANDER</option>                    
                            <option value={353}>353 - BANCO SANTANDER BRASIL</option>             
                            <option value={356}>356 - BANCO ABN AMRO REAL SA </option>            
                            <option value={394}>394 - BANCO BMC SA</option>                       
                            <option value={399}>399 - HSBC BANK BRASIL</option>                   
                            <option value={409}>409 - UNIBANCO - UNIAO DE BANCOS BRA</option>     
                            <option value={422}>422 - BANCO SAFRA</option>                        
                            <option value={453}>453 - BANCO RURAL </option>                       
                            <option value={477}>477 - CITIBANK SA </option>                       
                            <option value={623}>623 - BANCO PANAMERICANO</option>                 
                            <option value={744}>744 - BANKBOSTON </option>                        
                            <option value={745}>745 - BANCO CITIBANK</option>      

                        </select>
                    </div>

                    <div className="col-6">
                        <label htmlFor="inputAddress" className="form-label">Descrição</label>
                        <input type="text" onChange={(e)=> setDescricao(e.target.value)} value={descricao} className="form-control" id="inputAddress" />
                    </div>
                    
                    <div className="col-4">
                            <label htmlFor="inputAddress" className="form-label">Nº Agência</label>
                            <input type="text" onChange={(e)=> setNum_Agencia(e.target.value)} value={num_agencia} className="form-control" id="inputAddress" />
                        </div>

                        <div className="col-2">
                            <label htmlFor="inputAddress" className="form-label">Digito</label>
                            <input type="text" onChange={(e)=> setDigito_Agencia(e.target.value)} value={digito_agencia}className="form-control" id="inputAddress" />
                        </div>

                        <div className="col-4">
                            <label htmlFor="inputAddress" className="form-label">Nº Conta</label>
                            <input type="text" onChange={(e)=> setNumConta(e.target.value)} value={num_conta} className="form-control" id="inputAddress" />
                        </div>

                        <div className="col-2">
                            <label htmlFor="inputAddress" className="form-label">Digito</label>
                            <input type="text" onChange={(e)=> setDigito_Conta(e.target.value)} value={digito_conta}className="form-control" id="inputAddress" />
                        </div>

                        <div className="col-4">
                        <label htmlFor="inputAddress" className="form-label">Conta Reduzida(Contabilidade)</label>
                        <input type="text" onChange={(e)=> setConta_Corrente(e.target.value)} value={conta_corrente} className="form-control" id="inputAddress" />
                    </div>

                    <div className="col-3">
                        <label htmlFor="inputAddress" className="form-label">Data Último Movimento</label>
                        <input type="date" value={dataUltimoMov} onChange={(e)=> setDataUltimoMov(e.target.value)} className="form-control" id="inputAddress" />
                    </div>
                    <h1></h1>
                    <h6>dados complementares</h6>
                    <hr />
                    <div className="form-check">
                        <input
                         className="form-check-input"
                         type="checkbox"
                         checked={usaBoleto}  // O checkbox estará marcado conforme o estado usaBoleto
                         onChange={(e) => setUsaBoleto(e.target.checked)}  // Atualiza usaBoleto quando o checkbox for alterado
                         id="flexCheckDefault"
                        />
                       <label className="form-check-label" htmlFor="flexCheckDefault">
                       Usa Boleto
                      </label>
                     </div>
                        
                        
                    
                       
                        {usaBoleto === true?
                          <div className="boleto">
                            <div className="d-flex">
                                <div className="col-5">
                                    <label htmlFor="inputAddress" className="form-label">Número Carteira</label>
                                    <input type="text" onChange={(e)=> setNum_carteira(e.target.value)} value={num_carteira} className="form-control" id="inputAddress" />
                                </div>


                                <div className="col-5">
                                        <label htmlFor="inputAddress" className="form-label">Cod. Cedente</label>
                                        <input type="text" onChange={(e)=> setcedente_caixaEcon(e.target.value)} value={cedente_caixaEcon} className="form-control" id="inputAddress" />
                                </div>

                                <div className="col-2">
                                    <label htmlFor="inputAddress" className="form-label">DV</label>
                                    <input type="text" onChange={(e)=> setCEDENTE_DV(e.target.value)} value={cedente_dv} className="form-control" id="inputAddress" />
                                </div>

                             </div>

                                <div className="col-12">
                                    <label htmlFor="inputAddress" className="form-label">Local Pagamento</label>
                                    <input type="text" onChange={(e)=> setLOCALPAGAMENTO(e.target.value)} value={localPagamento} className="form-control" id="inputAddress" />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="inputAddress" className="form-label">Msg. 01</label>
                                    <input type="text" onChange={(e)=> setINSCOB01(e.target.value)} value={inscob01} className="form-control" id="inputAddress" />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="inputAddress" className="form-label">Msg. 02</label>
                                    <input type="text" onChange={(e)=> setINSCOB02(e.target.value)} value={insccob02} className="form-control" id="inputAddress" />
                                </div>

                                 <hr />




                              <div className="col-12 d-flex">
                              <div className="col-6">
                <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">Juros</label>
                </div>

                <div className="form-check form-check-inline">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="jurosOptions"
                        id="inlineRadio1"
                        value="F"
                        checked={tpJuros === 'F'}
                        onChange={handleJurosChange}
                    />
                    <label className="form-check-label" htmlFor="inlineRadio1">Nenhum</label>
                </div>
                <div className="form-check form-check-inline">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="jurosOptions"
                        id="inlineRadio2"
                        value="T"
                        checked={tpJuros === 'T'}
                        onChange={handleJurosChange}
                    />
                    <label className="form-check-label" htmlFor="inlineRadio2">Valor</label>
                </div>
                <div className="form-check form-check-inline">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="jurosOptions"
                        id="inlineRadio3"
                        value="%"
                        checked={tpJuros === '%'}
                        onChange={handleJurosChange}
                    />
                    <label className="form-check-label" htmlFor="inlineRadio3">Percentual</label>
                </div>

                <div className="col-4">
                    <input
                        type="text"
                        onChange={(e) => setJUROSCOB(e.target.value)}
                        value={jurosCod}
                        className="form-control"
                        id="inputAddress"
                    />
                </div>
            </div>

            <div className="col-6">
                <div className="col-3">
                    <label htmlFor="inputAddress" className="form-label">Multa</label>
                </div>

                <div className="form-check form-check-inline">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="multaOptions"
                        id="inlineRadio4"
                        value="F"
                        checked={tpMulta === 'F'}
                        onChange={handleMultaChange}
                    />
                    <label className="form-check-label" htmlFor="inlineRadio4">Nenhum</label>
                </div>
                <div className="form-check form-check-inline">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="multaOptions"
                        id="inlineRadio5"
                        value="T"
                        checked={tpMulta === 'T'}
                        onChange={handleMultaChange}
                    />
                    <label className="form-check-label" htmlFor="inlineRadio5">Valor</label>
                </div>
                <div className="form-check form-check-inline">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="multaOptions"
                        id="inlineRadio6"
                        value="%"
                        checked={tpMulta === '%'}
                        onChange={handleMultaChange}
                    />
                    <label className="form-check-label" htmlFor="inlineRadio6">Percentual</label>
                </div>

                <div className="col-4">
                    <input
                        type="text"
                        onChange={(e) => setMULTACOB(e.target.value)}
                        value={multaCod}
                        className="form-control"
                        id="inputAddress"
                    />
                </div>
            </div>
                                </div> 
                            
                                 <hr />

                            <div className="col-12 espaco"></div>

                            <div className="col-md-10">
                            <label htmlFor="inputState" className="form-label">Instruções de Cobrança</label>
                            <select id="inputState" onChange={(e)=> setINSTRUCAO_COBRANCA(e.target.value)} value={instrucao_cobranca} className="form-select">
                                <option value={'0'}>00 - selecione a instrução que vai aparecer no boleto</option>
                                <option value={'19'}>19 - não receber após 05 dias do vencimento</option>
                                <option value={'20'}>20 - não receber após 10 dias do vencimento</option>
                                <option value={'21'}>21 - não receber após 15 dias do vencimento</option>
                                <option value={'22'}>22 - não receber após 20 dias do vencimento</option>
                                <option value={'23'}>23 - não receber após 25 dias do vencimento</option>
                                <option value={'24'}>24 - não receber após 30 dias do vencimento</option>
                                <option value={'25'}>25 - não receber após 35 dias do vencimento</option>
                                <option value={'26'}>26 - não receber após 40 dias do vencimento</option>
                                <option value={'27'}>27 - não receber após 45 dias do vencimento</option>
                                <option value={'28'}>28 - não receber após 50 dias do vencimento</option>
                                <option value={'29'}>29 - não receber após 55 dias do vencimento</option>                                                       
                            </select>
                        </div>






                            </div>                     
                        :null
                       }    
                        

                        

                        <div className="col-12">
                            <Link to="/app/banco" type="submit" className="btn btn-outline-primary butao">Desistir</Link>
                          {tag != '0'? ( 
                          <button type="button" onClick={SalvaBanco} className="btn btn-primary butao">Salvar</button>):null}
                        </div>                   
                        
                        {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
                        {sucesso === 'S' ? <Navigate to='/app/banco' /> : null}
        
                    </form> 

                    <hr />
                </div>

                {
           erroValidacao ? 
           <SweetAlert
              danger
              confirmBtnText="OK"
              confirmBtnBsStyle="danger"
              title="Erro"
              onConfirm={() => setErrovalidacao(false)}                            
            >
              {msgErro}
            </SweetAlert>:null
           
          }
        </div>  
        <FooterBar/> 
   </div>

}



export default NovoBanco;